// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCardHeaderTitle-Title_cls1__VNnrQ","cls2":"VeloCardHeaderTitle-Title_cls2__LjZ7B VeloCardHeaderTitle-Title_cls1__VNnrQ"};